import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { IgnoreConflict } from '../../store/bid/types';
import { MiniButton } from '../ui/inputs/MiniButton/MiniButton';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AppState } from '../../store/state';
import { AppDispatch } from '../../store/store';
import assignmentSlice from '../../store/review/slice';

interface Props extends GridCellProps {
  ignoreConflictAction: (data: IgnoreConflict) => void;
}

const ConflictCell: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const hasConflict = props.dataItem[props.field || ''];
  const isIgnored = props.dataItem['ignored'];
  const isAssigned = props.dataItem['assigned'];

  return (
    <td
      colSpan={props.colSpan}
      className={props.className}
      role="gridcell"
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      style={props.style}
    >
      <div className="flex items-center">
        <div>
          <span>{hasConflict ? 'true' : 'false'}</span>
        </div>
        {hasConflict && isAssigned && (
          <div>
            <MiniButton
              labelText={isIgnored ? t('Ignored conflicts') : t('Ignore conflicts')}
              success={isIgnored}
              onButtonClick={
                isIgnored
                  ? undefined
                  : () =>
                      props.ignoreConflictAction({
                        assignment_id: props.dataItem['assignment_id'],
                        tableFriendlyName: props.dataItem['table_friendly_name'],
                      })
              }
            />
          </div>
        )}
      </div>
    </td>
  );
};

const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  ignoreConflictAction: (data: IgnoreConflict) =>
    dispatch(assignmentSlice.actions['ASSIGNMENTS:IGNORE_CONFLICT'](data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConflictCell);
